import { Component, OnInit } from '@angular/core';
import { DataService } from '../../services/data.service';
import { LoginType } from '../../enums/login-type';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { AOSRouteDirection } from '../../enums/Aos-direction';
import { AosService } from '../../services/aos.service';
import { PlatformEnum } from 'src/utils/environmentStore';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {

  loginTypes = LoginType;
  aosRouteDirection = AOSRouteDirection;

  constructor(
    private dataService: DataService,
    private router: Router,
    private userService: AosService) { }

  ngOnInit(): void {
    
    
    this.dataService.hideFooter.next(false);
  }

  routeToAOSWithDirection(direction) {
    var now = new Date();
    var dateNowCode = btoa(now.toString());

    var link = environment.aosURL + `/vertical/action-visit?dir=${direction}&dc=${dateNowCode}`;
    window.open(link, '_blank');
  }

  routeToAOS() {
    var link = environment.aosURL + `/sign-in`;
    window.open(link, '_blank');
  }

  routeToIntegraCloud() {
    switch (environment.platForm) {
      case PlatformEnum.EU:
        window.open('https://integra-cloud.myamadeo.eu', '_blank');
        break;
      case PlatformEnum.NET:
        window.open('https://integra-cloud.myamadeo.net', '_blank');
        break;
      case PlatformEnum.US:
        window.open('https://integra-cloud.myamadeo.com', '_blank');
        break;
    
      default:
        window.open('https://integra-cloud.myamadeo.eu', '_blank');
        break;
    }
    // window.open('https://integra-cloud.myamadeo.eu', '_blank');
    // window.open('https://integra-cloud.myamadeo.com', '_blank');
    // window.open('https://integra-cloud.myamadeo.net', '_blank');
  }
  routeToMobileReception() {
    switch (environment.platForm) {
      case PlatformEnum.EU:
        window.open('https://mobile-reception.skyaccess.eu', '_blank');
        break;
      case PlatformEnum.NET:
        window.open('https://mobile-reception.myamadeo.net', '_blank');
        break;
      case PlatformEnum.US:
        window.open('https://mobile-reception.myamadeo.com', '_blank');
        break;
    
      default:
        window.open('https://mobile-reception.skyaccess.eu', '_blank');
        break;
    }
    // window.open('https://mobile-reception.skyaccess.eu', '_blank');
    // window.open('https://mobile-reception.myamadeo.com', '_blank');
    // window.open('https://mobile-reception.myamadeo.net', '_blank');
  }
  routeToFreeflexPlanner() {
    switch (environment.platForm) {
      case PlatformEnum.EU:
        window.open('https://freeflex.myamadeo.net/vertical/freeflex', '_blank');
        break;
      case PlatformEnum.NET:
        window.open('https://freeflex.myamadeo.net/vertical/freeflex', '_blank');
        break;
      case PlatformEnum.US:
        window.open('https://freeflex.myamadeo.com/vertical/freeflex', '_blank');
        break;
    
      default:
        window.open('https://freeflex.myamadeo.net/vertical/freeflex', '_blank');
        break;
    }
    window.open('https://freeflex.myamadeo.net/vertical/freeflex', '_blank');
  }

  openAbooking() {
    return;
    window.open('https://www.skyaccess.eu/a-booking/admin881zxdvuh/index.php?controller=AdminProducts&token=0bb223d73a9a0f395139328d05fe6c57', '_blank')
  }

}
